import { TooltipProvider } from "@/shared/components/ui/tooltip";

import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "@/shared/components/ui/resizable";
import { Separator } from "@/shared/components/ui/separator";
import { Search } from "lucide-react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/shared/components/ui/tabs";
import { Input } from "@/shared/components/ui/input";
import { MailList } from "./inbox-list";
import { useState } from "react";
import { MailDisplay } from "./inbox-display";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { useDispatch, useSelector } from "@/core/redux/store";
import { getInbox } from "@/core/redux/thunks/inboxThunk";

export function InboxPageSection({ defaultLayout = [20, 32, 48] }: any) {
  const [activeTab, setActiveTab] = useState("all");
  const dispatch = useDispatch();

  const me = useSelector((state) => state.user.me);
  const { t } = useTranslation();

  const handleGetInbox = (tab: boolean) => {
    if (me && me.id) {
      dispatch(getInbox({ userId: me.id, isRead: tab }));
    }
  };

  return (
    <TooltipProvider delayDuration={0}>
      <ResizablePanelGroup
        direction="horizontal"
        onLayout={(sizes: number[]) => {
          document.cookie = `react-resizable-panels:layout:mail=${JSON.stringify(
            sizes
          )}`;
        }}
        className=""
        style={{
          height: "96vh",
        }}
      >
        <ResizablePanel defaultSize={defaultLayout[1]} minSize={30}>
          <Tabs
            value={activeTab}
            onValueChange={(value) => setActiveTab(value)}
          >
            <div className="flex items-center px-4 py-2">
              <h1 className="text-[16px] font-600 text-[#181818]">
                {t("inbox:inbox")}
              </h1>
              <TabsList className="ml-auto p-1">
                <TabsTrigger
                  value="all"
                  className={cn(
                    "dark:text-zinc-200 font-600 text-[14px]",
                    activeTab === "all"
                      ? "bg-white text-foreground text-[#181818]"
                      : "text-[#52525B]",
                    "!h-[30px]"
                  )}
                  onClick={() => handleGetInbox(true)}
                >
                  {t("inbox:all")}
                </TabsTrigger>
                <TabsTrigger
                  value="unread"
                  className={cn(
                    "dark:text-zinc-200 font-600 text-[14px]",
                    activeTab === "unread"
                      ? "bg-white text-foreground text-[#181818]"
                      : "text-[#52525B]",
                    "!h-[30px]"
                  )}
                  onClick={() => handleGetInbox(false)}
                >
                  {t("inbox:unread")}
                </TabsTrigger>
              </TabsList>
            </div>
            <Separator />
            <div className="bg-background/95 p-4 backdrop-blur supports-[backdrop-filter]:bg-background/60">
              <form>
                <div className="relative">
                  <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
                  <Input
                    placeholder="Search"
                    className="pl-8 !h-[40px] placeholder:text-muted-foreground placeholder:text-[16px] placeholder:font-500 "
                  />
                </div>
              </form>
            </div>
            <TabsContent value="all" className="m-0">
              <MailList />
            </TabsContent>
            <TabsContent value="unread" className="m-0">
              <MailList />
            </TabsContent>
          </Tabs>
        </ResizablePanel>
        <ResizableHandle withHandle />
        <ResizablePanel defaultSize={defaultLayout[2]} minSize={30}>
          <MailDisplay />
        </ResizablePanel>
      </ResizablePanelGroup>
    </TooltipProvider>
  );
}
